import React, { useEffect } from "react"
import { BidModel } from "../../../models/bid/BidModel"
import { Organisation } from "../../../models/organisation/Organisation"
import { colorPrimaryDark } from "../../../rsc/colors/colors"
import { QBPPriceRow } from "./QBPPriceRow"
import { isArrayNullOrEmpty } from "../../../helper/helper"
import { t } from "i18next"
import { OrgBidModel } from "../../../models/bid/OrgBidModel"

type Props = {
    org: OrgBidModel
    basePrice: BidModel
}

export function QBPPriceSection({ org, basePrice }: Props) {

    return <div style={{ display: !isArrayNullOrEmpty(basePrice.qbp) ? 'block' : 'none', width:'100%' }}>
        <p className='lightGreyBgColor padding10 bold font-20'>{t('quality_level')}</p>
        <div className='bold' style={{ display: "flex", alignItems: "center", paddingLeft: "10px", gap: '10px', marginBottom: '10px', color: colorPrimaryDark() }}>
            <div style={{ flex: 1, display: "flex" }}>
                {t('name')}
            </div>
            <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>
            {t('bonus')}
            </div>
            <div style={{ flex: 1, justifyContent: "end", display: "flex" }}>
            {t('total')}
            </div>
            <div style={{ width: "100px" }} />
        </div>
        {basePrice.qbp?.map(q => {
            return <QBPPriceRow key={q.name + org.organisationName} quality={q} bid={basePrice} org={org} />
        })
        }
    </div>

}